var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container ombre",attrs:{"id":"app"}},[_c('header-component'),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('footer-component')],1)}
var staticRenderFns = []

export { render, staticRenderFns }